// base class for all API clients
import axiosInstance, { DEFAULT_AXIOS_OPTIONS } from 'services/APIService';
import type { AxiosInstance, AxiosRequestConfig } from 'axios';

type RequestMethodHandlerName = 'get' | 'post' | 'put' | 'delete' | 'head' | 'patch';

type RequestArgs = [string, any?, AxiosRequestConfig<any>?];

type ApiCallAxiosProps = {
  uri?: string;
  method?: RequestMethodHandlerName;
  data?: any;
  cfg?: AxiosRequestConfig<any>;
  apiUri?: string;
};

export default abstract class ApiClientBase {
  abstract apiUri: string;

  axiosInstance: AxiosInstance | null = null;

  protected async apiCall<T>(
    uri: string | ApiCallAxiosProps = '',
    method: RequestMethodHandlerName = 'get',
    data?: any,
    cfg?: AxiosRequestConfig<any>,
    apiUri = this.apiUri,
  ): Promise<T> {
    if ('string' != typeof uri) ({ uri = '', method = 'get', data, cfg, apiUri = this.apiUri } = uri);

    if (uri && uri.slice(0, 1) != '/') {
      uri = '/' + uri;
    }
    let url = apiUri + uri;
    if (method == 'get' && data) {
      url += `?${data}`;
    }

    if (!cfg) {
      cfg = DEFAULT_AXIOS_OPTIONS;
    }

    // an alternative to request injection
    /*
    if (authToken) {
      if (!cfg.headers) cfg.headers = {};
      cfg.headers.Authorization = 'Bearer ' + authToken;
    }
    */

    const requestArgs: RequestArgs = [url, cfg];
    if (method == 'post' || method == 'put' || method == 'patch') {
      requestArgs.splice(1, 0, data);
    }

    let payload: T | undefined;
    try {
      const axios = this.axiosInstance || axiosInstance;
      const response = await axios[method]<T>(...requestArgs);
      payload = response?.data;
    } catch (err) {
      throw err;
    }

    return payload || (null as T);
  }
}
